import { useEffect, useState } from "react";
import { getToken } from "../utility/Constant";

const useSession = () => {
  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(true);

  const url = `${process.env.REACT_APP_API_URL}api/v1/user/me`;
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + getToken(),
    },
  };

  useEffect(() => {
    fetch(url, requestOptions)
      .then((res) => res.json())
      .then((data) => {
        setUser(data.data);
        setLoading(false);
      })
      .catch((err) => console.log(err));
  }, []);

  return [user, loading];
};

export default useSession;

export async function getUserInfo() {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + getToken(),
    },
  };
  const url = `${process.env.REACT_APP_API_URL}api/v1/user/me`;

  const response = await fetch(url, requestOptions)
    .then((res) => res.json())
    .then((data) => {
      return data.data;
    })
    .catch((err) => console.log(err));
  return response;
}
